import { isViewed as isViewedCluster } from '../../../../browser/utils/viewedClusters';
import { ICluster } from '../../repositories/dailyrent/entities/cluster/Cluster';
import { IFeaturesMap } from '../../types/map';

const POSUTOCHNO_CLUSTER_INDENTS = [
  [0, 0],
  [32, 0],
  [16, 64],
  [-16, 64],
  [-32, 0],
  [-16, -64],
  [16, -64],
];
const POSUTOCHNO_CLUSTER_FACTOR = 0.8;

// В посутке не используются кластера объединенные в одну точку на карте
// вместо этого кластеры разбиваются максимум на 7 частей и каждая часть отображается отдельно
export function convertClustersToFlatFeaturesMap(clusters: ICluster[], currentZoom: number): IFeaturesMap {
  const factor = POSUTOCHNO_CLUSTER_FACTOR / 2 ** currentZoom;

  return clusters?.reduce<IFeaturesMap>((result, cluster) => {
    const { coordinates, geohash, offers } = cluster;

    offers?.slice(0, 7).forEach((offer, index) => {
      const newGeohash = index === 0 ? geohash : `${geohash}${index}`;
      const lat = coordinates.lat + POSUTOCHNO_CLUSTER_INDENTS[index][0] * factor;
      const lng = coordinates.lng + POSUTOCHNO_CLUSTER_INDENTS[index][1] * factor;

      result[newGeohash] = {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [lat, lng],
        },
        id: newGeohash,
        properties: {
          ...cluster,
          coordinates: { lat, lng },
          geohash: newGeohash,
          offers: [{ ...offer, isViewed: offer.isViewed || isViewedCluster(offer.cianId) }],
        },
      };
    });

    return result;
  }, {});
}
